// extracted by mini-css-extract-plugin
export default {"particlesContainer":"Particles_particlesContainer__A7qZT"};